export enum GroupStatus {
    PRIVATE = "PRIVATE"
}
